<ion-tabs [class.nav-visible]="navbarVisibility.isVisible()" (ionTabsDidChange)="onTabChange($event)">
  @if (isBrowser && navbarVisibility.isVisible()) {
    <div class="navigation" [class.filters-expanded]="navbarVisibility.filtersExpanded()">
      <ion-tab-bar slot="bottom" class="nav-container">
        <ion-tab-button tab="home" class="nav-item" #homeTab [class.selected]="homeTab.selected" (click)="onTabClick($event, homeTab.selected)">
          <img class='icon icon-text-secondary' 
               [src]="homeTab.selected ? 'assets/icons/globe-americas-fill.svg' : 'assets/icons/globe-americas.svg'" 
               alt="Home">
          <ion-label [class]="homeTab.selected ? 'sub-bold ' : 'sub-medium'">{{ 'app.explore' | t }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="reciclar" class="nav-item" #reciclarTab [class.selected]="reciclarTab.selected" (click)="onTabClick($event, reciclarTab.selected)">
          <img class='icon icon-text-secondary' 
               [src]="reciclarTab.selected ? 'assets/icons/recycle-fill.svg' : 'assets/icons/recycle.svg'" 
               [alt]="'app.recycle' | t">
          <ion-label [class]="reciclarTab.selected ? 'sub-bold ' : 'sub-medium'">{{ 'app.recycle' | t }}</ion-label>
        </ion-tab-button>
    
        <ion-tab-button tab="material" class="nav-item" #materialTab [class.selected]="materialTab.selected" (click)="onTabClick($event, materialTab.selected)">
          <img class='icon icon-text-secondary' 
               [src]="materialTab.selected ? 'assets/icons/light-fill.svg' : 'assets/icons/light.svg'" 
               alt="Material">
          <ion-label [class]="materialTab.selected ? 'sub-bold ' : 'sub-medium'">{{ 'app.materials' | t }}</ion-label>
        </ion-tab-button>
    
        @if (isAdmin()) {
          <ion-tab-button class="nav-item self-end-admin" tab="admin" #adminTab [class.selected]="adminTab.selected" (click)="goToAdmin()">
            <img class='icon icon-text-secondary' 
                 src="assets/icons/wrench-screwdriver.svg" 
                 alt="Admin">
            <ion-label class="" [class]="adminTab.selected ? 'sub-bold ' : 'sub-medium'">Admin</ion-label>
          </ion-tab-button>
        }

        <ion-tab-button tab="profile" class="nav-item self-end" #profileTab [class.selected]="profileTab.selected" (click)="onTabClick($event, profileTab.selected)">
          <app-floating-badge [count]="unreadCount()" [show]="hasUnread()" variant="dot">
            @if (user()?.picture || user()?.avatar) {
              <img class='icon icon-text-secondary' 
                   [src]="user()?.picture || user()?.avatar" 
                   referrerpolicy="no-referrer"
                   [alt]="'app.profile' | t"
                   style="border-radius: 50%; object-fit: cover; filter: none;">
            } @else {
              <img class='icon icon-text-secondary' 
                   [src]="profileTab.selected ? 'assets/icons/person-fill.svg' : 'assets/icons/person.svg'" 
                   [alt]="'app.profile' | t">
            }
          </app-floating-badge>
          <ion-label [class]="profileTab.selected ? 'sub-bold ' : 'sub-medium'">{{ 'app.profile' | t }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </div>
  }
</ion-tabs>

<!-- Global Hover Tooltip -->
<app-hover-component></app-hover-component>

<!-- Lamaquina Recorder — Ctrl+Click to inspect components -->
<lamaquina-recorder
  backend-url="http://localhost:3001/api/v1/records"
  frontend-url="http://localhost:8100">
</lamaquina-recorder>